import { renderToStaticMarkup } from "react-dom/server";
import { QUADRO_DA_FACE, type MarcacaoFacial, type ModeloDaFace, type VistaDaFace } from "@bookdental/schemas";
import { imagemDaFace } from "./desenhos";
import { FormaDaMarcacao, QUADRO_VIEWBOX } from "./FormaDaMarcacao";

export type MarcaImpressa = { m: MarcacaoFacial; cor: string; numero: number };

/** SVG de uma vista com as marcações numeradas, em texto — pra janela de impressão. */
export function svgDaFace(modelo: ModeloDaFace, vista: VistaDaFace, marcas: MarcaImpressa[]) {
  // A janela de impressão não tem a origem do app: a imagem vai com o endereço completo.
  const href = new URL(imagemDaFace(modelo, vista), window.location.origin).href;
  return renderToStaticMarkup(
    <svg viewBox={QUADRO_VIEWBOX} xmlns="http://www.w3.org/2000/svg">
      <image href={href} width={QUADRO_DA_FACE.largura} height={QUADRO_DA_FACE.altura} />
      {marcas.map((k) => (
        <FormaDaMarcacao key={k.numero} m={k.m} cor={k.cor} numero={k.numero} />
      ))}
    </svg>,
  );
}
